import {
    addDoc,
    collection,
    deleteDoc,
    doc,
    getDoc,
    getDocs,
    getFirestore,
    query,
    updateDoc,
    where,
    writeBatch
} from "firebase/firestore";
import { Season } from "../types/season";
import firebaseClient from './firebase';

class SeasonService {

    collectionName = "season";
    db = getFirestore(firebaseClient);

    empty = async (): Promise<Season> => {
        const seasons = await this.getAll();
        const last = seasons.sort((s1, s2) => s2.year - s1.year)[0];

        return {
            id: '',
            year: last.year + 1,
            playerIds: last.playerIds
        }
    }

    getById = async (id: string): Promise<Season> => {
        try {
            const docRef = await getDoc(doc(this.db, this.collectionName, id));
            if (docRef.exists()) {
                return {
                    ...docRef.data(),
                    id: docRef.id
                } as Season;
            } else {
                throw Error(`season id: ${id}, does not exist`)
            }
        } catch (e) {
            console.error("Error adding document: ", e);
            throw e;
        }
    }

    // Add a document to a collection
    add = async (season: Season): Promise<void> => {
        try {
            const docRef = await addDoc(collection(this.db, this.collectionName), season);
            console.log("Document written with ID: ", docRef.id);
        } catch (e) {
            console.error("Error adding document: ", e);
        }
    }

    // Add a document to a collection
    update = async (season: Season): Promise<void> => {
        try {
            const docRef = doc(this.db, this.collectionName, season.id);
            return updateDoc(docRef, season);
        } catch (e) {
            console.error("Error adding document: ", e);
        }
    }

    // Get all documents from a collection
    getAll = async (): Promise<any[]> => {
        const querySnapshot = await getDocs(collection(this.db, this.collectionName));
        return querySnapshot.docs.map(doc => {
            return {
                ...doc.data(),
                id: doc.id
            }
        });
    }

    delete = async (element: Season): Promise<void> => {
        return deleteDoc(doc(this.db, this.collectionName, element.id));
    }


    addBatch = (seasons: Season[]) => {
        const batch = writeBatch(this.db);
        seasons.forEach(e => {
            const docRef = doc(this.db, this.collectionName, e.id);
            batch.set(docRef, e);
        })
        return batch.commit();
    }

    findByYear = async (year: number): Promise<Season | null> => {
        const seasonRef = collection(this.db, this.collectionName);
        const tournaments = query(seasonRef, where('year', '==', year));
        const querySnapshot = await getDocs(tournaments);
        let season: Season | null = null;
        querySnapshot.forEach((doc) => {
            season = {
                ...doc.data(),
                id: doc.id
            } as Season;
        });
        return season;
    }

    findLatest = async (): Promise<Season | null> => {
        const seasons = await this.getAll();
        return seasons.sort((s1, s2) => s2.year - s1.year)[0];
    }
}

const seasonService = new SeasonService()
export { seasonService };

